import React from 'react';
import { Check } from 'lucide-react';
import { cn } from '../../../utils/cn';

export type StepKey = 'upload' | 'review' | 'result';

interface StepperProps {
  current: StepKey;
  labels: Record<StepKey, string>;
}

const ORDER: StepKey[] = ['upload', 'review', 'result'];

export const Stepper: React.FC<StepperProps> = ({ current, labels }) => {
  const currentIdx = ORDER.indexOf(current);

  return (
    <ol className="flex items-center w-full" data-test-id="import-green-bean-stepper">
      {ORDER.map((step, idx) => {
        const isDone = idx < currentIdx;
        const isActive = idx === currentIdx;
        const isLast = idx === ORDER.length - 1;
        return (
          <li
            key={step}
            className={cn(
              'flex items-center',
              !isLast && 'flex-1',
            )}
          >
            <div className="flex items-center gap-2">
              <span
                className={cn(
                  'flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-xs font-semibold transition-colors',
                  isDone && 'bg-primary-600 text-white',
                  isActive && 'bg-primary-600 text-white ring-4 ring-primary-100',
                  !isDone && !isActive && 'bg-gray-100 text-gray-500 ring-1 ring-gray-200',
                )}
              >
                {isDone ? <Check className="h-3.5 w-3.5" /> : idx + 1}
              </span>
              <span
                className={cn(
                  'text-sm font-medium whitespace-nowrap',
                  isActive ? 'text-gray-900' : 'text-gray-500',
                )}
              >
                {labels[step]}
              </span>
            </div>
            {!isLast && (
              <span
                className={cn(
                  'mx-3 h-px flex-1 transition-colors',
                  isDone ? 'bg-primary-600' : 'bg-gray-200',
                )}
                aria-hidden="true"
              />
            )}
          </li>
        );
      })}
    </ol>
  );
};
